import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import MegaCollection from '~/components/BatchImport/MegaCollection';

const BatchImport = () => {
  const { url } = useRouteMatch();

  return (
    <Route
      exact
      path={url}
    >
      <MegaCollection />
    </Route>
  );
};

export default BatchImport;
